var App = App || {};

App.Alert = (function ($) {
    "use strict";

    var $alerts;

    function init() {
        $alerts = $('.alert');

        $alerts.each(function () {
            var $alert = $(this),
                alertId = $alert.data('alertid');

            $alert.on('click', '.alert-close', function (e) {
                e.preventDefault();
                dismissAlert($alert, alertId);
            });
        });
    }

    function dismissAlert($alert, alertId) {
        $alert.slideUp(300);
        App.Cookies.setItem("PeoplesAlertDismissed-" + alertId, "true");
    }

    function alertDismissed(alertId) {
        return App.Cookies.getItem("PeoplesAlertDismissed-" + alertId) === "true" ? true : false;
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Alert.init();
});